{
  "$id": "wealthlane://forms/customer-success-automation/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "semanticId": "customerSuccessAutomationForm",
  "wrapper": {
    "bordered": true,
    "padding": "30px 46px 32px 50px"
  },
  "submitBar": {
    "submitLabel": "Save",
    "align": "end",
    "hideCancel": true,
    "divider": false
  },
  "layout": [
    {
      "rowId": "source_section",
      "title": "Source",
      "columns": 2,
      "fields": [
        {
          "scope": "#/properties/sourceCompanyId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 600
        },
        {
          "scope": "#/properties/sourceRoleId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 600
        }
      ]
    },
    {
      "rowId": "destination_section",
      "title": "Destination",
      "divider": true,
      "columns": 2,
      "fields": [
        {
          "scope": "#/properties/destinationCompanyId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 600
        },
        {
          "scope": "#/properties/destinationRoleId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 600
        }
      ]
    }
  ]
}
